import { IsEmail, IsNotEmpty, IsOptional, IsString, IsStrongPassword, Length } from 'class-validator';

export class UserRegistrationCreationDto {
  @IsString()
  @IsNotEmpty()
  @Length(2, 50)
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  @Length(2, 50)
  lastName!: string;

  @IsString()
  @IsNotEmpty()
  @IsEmail()
  email!: string;

  @IsString()
  @IsNotEmpty()
  @IsStrongPassword()
  @Length(8, 30)
  password!: string;

  @IsString()
  @IsOptional()
  invitationToken?: string;
}
